/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardingLinkDetailModel } from '../../models/onboarding-link-detail-model';

export interface AdminBranchOnboardingListBranchIdGet$Params {
  branchId: string;
}

export function adminBranchOnboardingListBranchIdGet(http: HttpClient, rootUrl: string, params: AdminBranchOnboardingListBranchIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OnboardingLinkDetailModel>>> {
  const rb = new RequestBuilder(rootUrl, adminBranchOnboardingListBranchIdGet.PATH, 'get');
  if (params) {
    rb.path('branchId', params.branchId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<OnboardingLinkDetailModel>>;
    })
  );
}

adminBranchOnboardingListBranchIdGet.PATH = '/Admin/BranchOnboardingList/{branchId}';
